import { IconButton } from '@material-ui/core';
import { ArrowForwardIosRounded } from '@material-ui/icons';
import { ObjectContainerClientT } from 'bovaljaren-models';
import React, { ReactElement } from 'react';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { ObosChevronRight } from '../../../../../icons/obos/obosIcons';
import BrandingService from '../../../../../services/branding.service';
import ImageThumbnails from '../ImageThumbnails/ImageThumbnails';
import { CurrentImageT } from '../OV-subcomponents';

type ObjectViewImageGalleryProps={
    showImages: boolean;
    setImageIndex: (value: number) => void;
    imageIndex: number;
    prevImageIndex: number;
    setPrevImageIndex: (value:number) => void;
    currentImages?: CurrentImageT[];
    isModal?: boolean;
    currentImage?: CurrentImageT;
    selectedObject?: ObjectContainerClientT;
};

const ObjectViewImageGallery: React.FC<ObjectViewImageGalleryProps> = ({ showImages, isModal = false, imageIndex, setImageIndex, currentImages, currentImage, selectedObject, prevImageIndex, setPrevImageIndex }): ReactElement => {

    const imageArrayLength = currentImages?.length;

    const changeImageIndex = (direction: 'prev' | 'next') => {
        if (!imageArrayLength) return;

        switch (direction) {
        case 'prev':
            imageIndex !== 0 && setImageIndex(imageIndex - 1);
            imageIndex !== 0 && setPrevImageIndex(imageIndex);
            break;
        case 'next':
            imageIndex !== imageArrayLength - 1 && setImageIndex(imageIndex + 1);
            imageIndex !== imageArrayLength - 1 && setPrevImageIndex(imageIndex);
            break;
        }
    };

    const getArrow = () => {

        if (BrandingService.check(['obos']))
            return <ObosChevronRight/>;

        return <ArrowForwardIosRounded/>;
    };


    return (
        <>{showImages && currentImage && currentImage?.image &&
            <>
                <IconButton className={`bv-object-view-image-button bv-object-view-image-button-left ${isModal ? ' bv-object-view-image-button-left--modal' : ''}` } onClick={(): void => changeImageIndex('prev')}>{getArrow()}</IconButton>
                {showImages &&
                <>
                    {currentImages?.map((cI, index) => {
                        return <div key={cI.image.id} className={`bv-object-view-image ${currentImage.image.id === cI.image.id ? ' bv-object-view-image--current' : ''}${prevImageIndex === index ? ' bv-object-view-image--previous' : ''}`}>
                            { cI?.subtype === 'floorplan' && <div className={'bv-transform-wrapper'}><TransformWrapper limitToBounds={true} initialScale={1} minScale={1} initialPositionY={0}>
                                <TransformComponent>
                                    {cI?.image.type === 'image' && <img className={(cI?.subtype === 'floorplan' && !selectedObject?.imageCollectionId) ? 'bv-object-view-floorplan-modal-img--floorplan' : 'bv-object-view-floorplan-modal-img'} src={cI.image.url?.large} alt=''/>}
                                </TransformComponent>
                            </TransformWrapper></div>}
                            { cI?.subtype === 'image' &&
                        <>
                            {cI?.image.type === 'image' && <img key={cI?.image.id} className={'bv-objectview-content-image'} alt={'Bild på lägenhet'} src={cI?.image.url?.large}/>}
                            {cI?.image.caption && currentImage?.image.caption !== '' && <div className={'bv-objectview-content-caption'}><p>{currentImage?.image.caption}</p></div>}
                        </>}
                        </div>;
                    })}
                </>}
                <ImageThumbnails isModal={isModal} currentImage={currentImage} images={currentImages} onClick={(index): void => {
                    setImageIndex(index);
                }}/>
                <IconButton className={`bv-object-view-image-button bv-object-view-image-button-right  ${isModal ? ' bv-object-view-image-button-right--modal' : ''}`} onClick={(): void => changeImageIndex('next')}>{getArrow()}</IconButton>
            </>}</>
    );
};


export default ObjectViewImageGallery;